module.exports = __webpack_public_path__ + "dist/static/media/logo.569f9425.png";